// extracted by mini-css-extract-plugin
module.exports = {"container":"FrequentyAskedQuestion_container__2lQjz","subTitle":"FrequentyAskedQuestion_subTitle__SAKx4","section":"FrequentyAskedQuestion_section__25tp6"};